export const YES = 'yes';
export const NO = 'no';
export const OFF = 'off';
export const V1 = 'v1';
export const V2 = 'v2';
export const ENABLE_FIVE_YEAR_SEARCH = 'number_of_years_to_search';
export const SHOW_ANALYZE_WELCOME_SCREEN = 'show_analyze_welcome_screen';
export const SEARCH_SHOW_TOPICS = 'search_show_topics';
export const ENABLE_UNIQUE_ONLINE_VISITORS = 'enable_unique_online_visitors';
export const DISCLAIMER_DATE_NEWSLETTER = 'disclaimer_date_newsletter';
export const DISCLAIMER_DATE_SEARCH = 'disclaimer_date_search';
export const ENABLE_MEDIA_VALUE = 'enable_media_value';
export const SHOW_SEARCH_ASSISTANT = 'show_search_assistant';
export const ENABLE_ARCHIVE_SEARCH_MODE = 'enable_archive_search_mode';
export const NUMBER_OF_HEADLINES_TO_SHOW = 'number_of_headlines_to_show';
export const ARTICLE_HARVEST_TIME = 'article_harvest_time';
export const DISPLAY_DUPLICATES_FROM = 'display_duplicates_from';
export const ENABLE_EMAIL_MANAGER = 'enable_email_manager';
export const ENABLE_USER_MANAGER = 'enable_user_manager';
export const SHOW_EMAIL_THEMES_SUBTAB = 'show_email_themes_subtab';
export const ENABLE_ARCHIVE_TAB = 'enable_archive_tab';
export const SHOW_EXPORT_TAB = 'show_export_tab';
export const EXPORT_RICH_XML_PERMISSION = 'export_rich_xml_permission';
export const ENABLE_ANALYZE_TAB = 'enable_analyze_tab';
export const DATE_FORMAT = 'date_format';
export const ENABLE_PRODUCT_OVERVIEW_REPORT = 'product_overview_report';
export const SEARCH_SUMMARY_OPEN = 'search_summary_open';
export const SEARCH_TRENDS_OPEN = 'search_trends_open';
export const CLIPPINGS_DROPDOWN_TAB_INDEX = 'clippings_dropdown_tab_index';
export const TAGS_DROPDOWN_TAB_INDEX = 'tags_dropdown_tab_index';
export const MEDIA_CONTACTS_NAVLINK = 'media_contacts_navlink';
export const SOCIAL_ANALYTICS_NAVLINK = 'social_analytics_navlink';
export const MAX_FEEDS_PER_ALERT = 'feeds_per_alert';
export const ALLOW_EMAIL_SOURCE_MANAGEMENT = 'allow_email_source_management';
export const ENABLE_CONTENT_DISRUPTION_NOTIFICATION_EMAIL = 'enable_content_disruption_notification_email';
export const MAX_CHARTS_IN_ALERT = 'max_charts_in_alert';
export const ENABLE_PPT_APPENDIX = 'enable_ppt_appendix';
export const SHOW_ARTICLE_EXTRACTS = 'show_article_extracts';
export const DATE_FILTER_SHOW_DISABLED_DATES = 'date_filter_show_disabled_dates';
export const DOWNLOAD_WITH_FULL_CONTENT = 'download_with_full_content';
export const ENABLE_ELASTIC = 'enable_elastic';
export const HEADLINE_DEDUPLICATION = 'headline_deduplication';
export const ENABLE_INSIGHTS_ON_DASHBOARD = 'enable_insights_on_dashboard';

export const SHOW_ARTICLE_EXTRACTS_VALUE = {
    FULL: 'full',
    CONTEXTUAL: 'contextual',
    START: 'start',
    NONE: 'none'
};

export const ARTICLE_HARVEST_TIME_VALUE = {
    EXACT: 'exact',
    RELATIVE: 'relative'
};

export const LEFT_NAVIGATION_AUTO_SHOW_FILTERS = 'left_navigation_auto_show_filters';
export const ENABLE_USAGE_STATS_UI = 'admin_usage_stats_ui';
export const NAV_LINK_URL = 'extra_navlink_url';
export const NAV_LINK_LABEL = 'extra_navlink_label';
export const CAN_EDIT_SHARED_SOURCE_LISTS = 'can_edit_shared_source_lists';
export const RESULTS_SHOW_IMAGES = 'results_show_images';
export const RESULTS_SHOW_ARTICLE_ID = 'results_show_article_id';
export const ENABLE_SELF_SERVICE_NEWSLETTERS = 'enable_self_service_newsletters';
export const ENABLE_SEARCH_BOX_V2 = 'enable_search_box_v2';
export const ENABLE_SEARCH_BOX_V2_ALWAYS = 'enable_search_box_v2_always';
export const ENABLE_TAG_MANAGER = 'enable_tag_manager';
export const NEWSDESK_LOCALE_OVERRIDE = 'newsdesk_locale_override';
export const NEWSLETTER_LICENCE = 'newsletter_licence';
export const SHOW_POST_SEARCH_GUIDANCE = 'show_post_search_guidance';
export const ENABLE_NEWSLETTER_VIEW_APP = 'enable_newsletter_view_app';
export const SHOW_LANDING_SCREEN = 'show_landing_screen';
export const EMAIL_REPLY_TO = 'email_replyto';
export const ENABLE_NEWSLETTER_DUPLICATES = 'enable_newsletter_duplicates';
export const ENABLE_NEWSLETTER_DATE_RANGE = 'enable_newsletter_date_range';
export const LANGUAGE_TRANSLATE_TO = 'language_translate_to';
export const MEDIA_VALUE_CURRENCY = 'media_value_currency';
export const SELECT_BOOLEAN_SEARCH_AS_DEFAULT = 'select_boolean_search_as_default';
export const QUICK_SEARCH_ENTITY_DESCRIPTION = 'quick_search_entity_description';
export const ENABLE_ENTITY_PREVIEW = 'enable_entity_preview';
export const PROJECT_ID = 'project_id';
export const SEARCH_RESULTS_ANALYSIS_PRIMARY_CHART = 'search_results_analysis_primary_chart';
export const PREMIUM_SOCIAL_MEDIA = 'premium_social_media';
export const MAX_NUMBER_OF_TWITTER_STREAMS = 'max_number_of_twitter_streams';
export const TWITTER_TERMS_ACCEPT_DATE = 'twitter_terms_accept_date';
export const ENABLE_AUTHOR_CHART = 'enable_author_chart';
export const ENABLE_AUTOMATED_CURATION = 'enable_automated_curation';
export const HIDE_UPSELL_PROMPTS = 'hide_upsell_prompts';
export const ENABLE_UNIQUE_SOURCES = 'enable_unique_sources';
export const JOURNALIST_CONTACT_CARD = 'journalist_contact_card';
export const FOLDER_MENU_ENABLE_EXTRA_ACTIONS = 'folder_menu_enable_extra_actions';
export const INSIGHTS_PPT = 'insights_ppt';
export const SHOW_ONBOARDING = 'show_onboarding';
export const CUSTOMER_LATEST_STORIES_FEED_ID = 'customer_latest_stories_feed_id';
export const ENABLE_SURVEY = 'enable_survey';
export const SHOW_SURVEY = 'show_survey';
export const SURVEY_PROFESSIONAL_ROLE = 'survey_professional_role';
export const SURVEY_PROFESSIONAL_USE = 'survey_professional_use';
export const USE_NEW_REACH_AND_MEDIA_VALUE = 'use_new_reach_and_media_value';
export const SUBSCRIPTION_INBOX_EMAIL_ADDRESS = 'subscription_inbox_email_address';
export const ENABLE_SIMILAR_ARTICLES = 'enable_similar_articles';
export const SHOW_NEWSLETTER_FEEDS_ON_HOVER = 'show_newsletter_feeds_on_hover';

export const NEWSDESK_DIRECT_CUSTOM_LOGO_PATH = 'newsdesk_direct_custom_logo_path';
export const ENABLE_PUBLIC_GROUPS = 'enable_public_groups';
export const HIDE_TAGS_FOR_NEWSDESK_DIRECT_USERS = 'hide_tags_for_newsdesk_direct_users';
export const ALLOW_NEWSLETTERS_EXPORT_DATA = 'allow_newsletters_export_data';

export const ENABLE_ARTICLE_PREVIEW_AI_SUMMARISATION = 'enable_article_preview_ai_summarisation';
export const USE_NEW_ENTITY_FIELDS = 'use_new_entity_fields';
